var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{key:_vm.componentKey,staticClass:"address",attrs:{"counter":_vm.counter,"rules":[_vm.validateRequired],"required":_vm.required,"maxlength":_vm.maxLength,"disabled":_vm.disabled},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }